import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";

import { PolicyholderType } from "@covertree/agent-portal-graphql";
import { AGENT_HELP_ADDRESS } from "@consts/index";
import {
  ContactInfo,
  MailingAddress,
  OrganizationDetails,
  PrimaryInsured,
  RepresentativeDetails,
} from "./PersonalDetailsSections";
import { PolicyDetailsContentProps } from "../../types";

export function PersonalDetails({
  policy,
  loading,
  error,
}: PolicyDetailsContentProps) {
  if (!loading && error)
    return (
      <Box>
        <Typography variant="subtitle1" color="black" textAlign="center">
          Policy was not found. Please contact us via email at{" "}
          <Link color="secondary" href={`mailto:${AGENT_HELP_ADDRESS}`}>
            {AGENT_HELP_ADDRESS}
          </Link>
          .
        </Typography>
      </Box>
    );

  return (
    <Grid container spacing={2}>
      {policy.policyholder.type === PolicyholderType.Person ? (
        <PrimaryInsured policy={policy} loading={loading} />
      ) : (
        <>
          <OrganizationDetails policy={policy} loading={loading} />
          <RepresentativeDetails policy={policy} loading={loading} />
        </>
      )}

      <ContactInfo policy={policy} loading={loading} />
      <MailingAddress policy={policy} loading={loading} />
    </Grid>
  );
}
